import { panelApi, panelGroupApi } from "./business";
import * as R from 'ramda';
export var STATIC_CONTENT = getStaticContent();
export function fetchPanelApi(panelCode, backup) {
  var panel = R.find(function (panel) {
    return panel.code === panelCode;
  }, STATIC_CONTENT.panels);
  return panel ? panelApi(panel) : backup ? panelApi(backup) : null;
}
export function fetchPanelGroupApi(pgCode, backup) {
  var pg = R.find(function (pg) {
    return pg.code === pgCode;
  }, STATIC_CONTENT.panelGroups);
  return pg ? panelGroupApi(pg) : backup ? panelGroupApi(backup) : null;
}
export function getStaticContent() {
  try {
    var language = getContentLanguage();
    if (!language) return window.STATIC_CONTENT[0];
    return window.STATIC_CONTENT.filter(function (c) {
      return c.language.toLowerCase() === language.toLowerCase();
    })[0];
  } catch (e) {
    return null;
  }
}
export function getContentLanguage() {
  try {
    var fromUrl = getParamValueFromUrlSearch('l');
    if (!!fromUrl) return fromUrl;
    return window.OPSEEKER_CONFIG.DEFAULT_LANGUAGE;
  } catch (e) {
    return null;
  }
}
export function getParamValueFromUrlSearch(paramName) {
  var queryString = window.location.search.slice(1).split("#")[0];
  var params = queryString.split("&");
  var paramValue = "";

  for (var i = 0; i < params.length; i++) {
    var param = params[i].split("=");
    paramValue = param[1];

    if (param[0] === paramName && paramValue.length > 0) {
      return paramValue;
    }
  }

  return "";
}